import { DownSquareOutlined } from '@ant-design/icons';
import Drawer from '@client/components/drawer/Drawer';
import { JSONTree } from 'react-json-tree';
import Styles from './Styles.module.scss';

const theme = {
    scheme: 'default',
    base00: '#ffffff',
    base01: '#f0f0f0',
    base02: '#e0e0e0',
    base03: '#d0d0d0',
    base04: '#606060',
    base05: '#202020',
    base06: '#000000',
    base07: '#000000',
    base08: '#ff0000',
    base09: '#ff9900',
    base0A: '#ff0099',
    base0B: '#00aa00',
    base0C: '#00aaaa',
    base0D: '#0000ff',
    base0E: '#9900ff',
    base0F: '#ff00ff',
};

export const ExtractionsDrawer = ({ open, onClose, data, setDrawerOpen }: any) => {
    return (
        <Drawer
            title="Extractions"
            open={open}
            onClose={onClose}
            placement="bottom"
            getContainer={false}
        >
            <div className={Styles.extractionsDrawerBody}>
                <DownSquareOutlined
                    onClick={() => setDrawerOpen(false)}
                    className={Styles.extractionsDrawerToggle}
                />
                <JSONTree
                    data={data}
                    theme={theme}
                    invertTheme={false}
                    shouldExpandNodeInitially={() => true}
                    hideRoot
                />
            </div>
        </Drawer>
    );
};
